/* Calabasas Skin Quiz engine — quiz → estimated type → curated routine builder. */
(function () {
  var root = document.querySelector('[data-sq]');
  if (!root) return;
  var dataEl = document.getElementById('sq-products');
  var PRODUCTS = [];
  try { PRODUCTS = JSON.parse(dataEl.textContent) || []; } catch (e) { PRODUCTS = []; }

  /* ---------- config ---------- */
  var ROUTINE = ['cleanser', 'toner', 'serum', 'moisturizer', 'sunscreen'];
  var STEP_LABEL = { cleanser: 'Cleanse', toner: 'Tone', serum: 'Treat', moisturizer: 'Hydrate', sunscreen: 'Protect', 'eye-care': 'Eyes', mask: 'Treat', 'lip-care': 'Lips' };
  var CAUTIONS = ['caution:fragrance', 'caution:essential-oil', 'caution:drying-alcohol', 'caution:strong-active'];

  var HERO = {
    cleanser: ['anua-heartleaf-pore-control-cleansing-oil', 'skin1004-madagascar-centella-ampoule-foam', 'round-lab-1025-dokdo-cleanser'],
    toner: ['heartleaf-77-soothing-toner', 'round-lab-1025-dokdo-toner', 'skin1004-madagascar-centella-toning-toner'],
    serum: ['glow-deep-serum-rice-alpha-arbutin', 'anua-niacinamide-10-txa-4-serum', 'skin1004-madagascar-centella-ampoule'],
    moisturizer: ['skin1004-madagascar-centella-soothing-cream', 'round-lab-1025-dokdo-cream', 'mary-may-sensitive-soothing-gel-cream'],
    sunscreen: ['relief-sun-rice-probiotics', 'skin1004-hyaula-cica-water-fit-sun-serum', 'abib-airy-sunstick-smoothing-bar']
  };

  var TYPE_COPY = {
    dry: "Your skin runs dry — it makes less of its own oil, so it can feel tight, look dull, or flake, especially in AC or cold air. Your focus: gentle cleansing and layered hydration that rebuilds the barrier.",
    oily: "Your skin makes plenty of oil — great for slower aging, but it can mean shine and congestion. Your focus: balance, not stripping — lightweight hydration and gentle exfoliation keep oil in check without triggering more.",
    combination: "Classic combination — an oilier T-zone with normal-to-dry cheeks. Your focus: balance the two zones with lightweight, layerable formulas instead of one heavy product everywhere.",
    normal: "Lucky you — your skin reads balanced. Your focus: protect what you've got with daily hydration and sunscreen, and treat specific concerns as they come up."
  };
  var TYPE_NAME = { dry: 'Dry', oily: 'Oily', combination: 'Combination', normal: 'Normal' };

  var MICRO = ["Nice — that helps us read your skin.", "Got it.", "Almost there.", "Two more.", "Last required one — Q7 is optional.", "Optional: skip if you're not sure."];

  /* ---------- questions ---------- */
  var Q = [
    { id: 'q1', eyebrow: 'Your goal', title: 'What do you most want to improve?', options: [
      { l: 'Calm breakouts', set: { concern: 'acne' } },
      { l: 'Fade dark spots / even tone', set: { concern: 'dark-spots' } },
      { l: 'Hydrate / plump', set: { concern: 'hydration' } },
      { l: 'Soothe redness / sensitivity', set: { concern: 'soothing', sensitive: true } },
      { l: 'Smooth fine lines / firm', set: { concern: 'anti-aging' } },
      { l: 'Control oil / minimize pores', set: { concern: 'pores' } },
      { l: "I'm just starting — keep it simple", set: { concern: 'none' } }
    ] },
    { id: 'q2', eyebrow: 'About you', title: 'Your age range?', options: [
      { l: 'Teens–20s', pts: { oily: 1 } }, { l: '30s', pts: {} }, { l: '40s', pts: { dry: 1 } }, { l: '50+', pts: { dry: 2 } }
    ] },
    { id: 'q3', eyebrow: 'Your world', title: 'The climate where you live?', options: [
      { l: 'Hot & humid', pts: { oily: 1 } }, { l: 'Dry or cold', pts: { dry: 1 } }, { l: 'Mild / temperate', pts: {} }, { l: 'Four distinct seasons', pts: { combination: 1 } }
    ] },
    { id: 'q4', eyebrow: 'Your days', title: "Most days, you're…", options: [
      { l: 'Mostly indoors, in AC or heat', pts: { dry: 1 } },
      { l: 'A mix of both', pts: {} },
      { l: 'Outdoors & active, sweating often', pts: { oily: 1 }, set: { spf: true } }
    ] },
    { id: 'q5', eyebrow: 'Sun', title: 'Do you wear sunscreen daily?', options: [
      { l: 'Yes, every day', pts: {} }, { l: 'Sometimes', set: { spf: true } }, { l: 'Rarely', set: { spf: true } }
    ] },
    { id: 'q6', eyebrow: 'Your skin', title: 'Day to day, your skin usually…', options: [
      { l: 'Gets shiny / oily', pts: { oily: 2 }, q6: 'oily' },
      { l: 'Feels tight or flaky', pts: { dry: 2 }, q6: 'dry' },
      { l: 'Shiny T-zone, drier cheeks', pts: { combination: 2 }, q6: 'combination' },
      { l: 'Gets red or irritated easily', set: { sensitive: true } },
      { l: 'Feels balanced / not sure', pts: {} }
    ] },
    { id: 'q7', optional: true, eyebrow: 'Optional', title: 'A few hours after washing, your skin feels…', options: [
      { l: 'Tight / dry', pts: { dry: 2 } },
      { l: 'Comfortable', pts: { normal: 1 } },
      { l: 'Oily all over', pts: { oily: 2 } },
      { l: 'Oily T-zone only', pts: { combination: 2 } },
      { l: "I'd rather skip", pts: {} }
    ] }
  ];

  /* ---------- state ---------- */
  var state = { idx: 0, answers: {}, points: {}, normal: 0, concern: 'none', sensitive: false, spf: false, q6type: null, type: 'normal', steps: {}, boosters: [] };

  function recompute() {
    state.points = { dry: 0, combination: 0, oily: 0 };
    state.normal = 0; state.concern = 'none'; state.sensitive = false; state.spf = false; state.q6type = null;
    Q.forEach(function (q) {
      var ai = state.answers[q.id];
      if (ai == null) return;
      var o = q.options[ai];
      if (!o) return;
      if (o.pts) Object.keys(o.pts).forEach(function (k) { if (k === 'normal') state.normal += o.pts[k]; else state.points[k] = (state.points[k] || 0) + o.pts[k]; });
      if (o.q6) state.q6type = o.q6;
      if (o.set) { if (o.set.concern) state.concern = o.set.concern; if (o.set.sensitive) state.sensitive = true; if (o.set.spf) state.spf = true; }
    });
    state.type = computeType();
  }

  function computeType() {
    var p = state.points;
    var max = Math.max(p.dry, p.combination, p.oily);
    if (max === 0) return 'normal';
    if (state.normal >= max && max <= 1) return 'normal';
    var leaders = ['dry', 'combination', 'oily'].filter(function (k) { return p[k] === max; });
    if (leaders.length === 1) return leaders[0];
    if (state.q6type && leaders.indexOf(state.q6type) > -1) return state.q6type;
    return 'combination';
  }

  /* ---------- recommendation ---------- */
  function hasAnyCaution(p, list) { for (var i = 0; i < list.length; i++) if (p.tags.indexOf(list[i]) > -1) return true; return false; }

  function rank(arr, step) {
    var c = state.concern, hero = HERO[step] || [];
    return arr.slice().sort(function (a, b) {
      if (c && c !== 'none') {
        var ca = a.tags.indexOf('concern:' + c) > -1 ? 0 : 1, cb = b.tags.indexOf('concern:' + c) > -1 ? 0 : 1;
        if (ca !== cb) return ca - cb;
      }
      var ha = hero.indexOf(a.handle), hb = hero.indexOf(b.handle);
      ha = ha < 0 ? 999 : ha; hb = hb < 0 ? 999 : hb;
      if (ha !== hb) return ha - hb;
      if (a.available !== b.available) return a.available ? -1 : 1;
      return a.title.localeCompare(b.title);
    });
  }

  function pickForStep(step) {
    var type = state.type;
    var pool = PRODUCTS.filter(function (p) { return p.tags.indexOf('step:' + step) > -1; });
    var cands = pool.filter(function (p) { return p.tags.indexOf('skin:' + type) > -1; });
    if (!cands.length) cands = pool.filter(function (p) { return p.tags.indexOf('skin:' + type) > -1 || p.tags.indexOf('skin:normal') > -1; });
    if (!cands.length) cands = pool.slice();
    var patch = false, filtered = cands;
    if (state.sensitive) {
      var strict = cands.filter(function (p) { return !hasAnyCaution(p, CAUTIONS); });
      if (strict.length) { filtered = strict; }
      else {
        var c2 = CAUTIONS.filter(function (c) { return c !== 'caution:fragrance'; });
        var s2 = cands.filter(function (p) { return !hasAnyCaution(p, c2); });
        if (s2.length) { filtered = s2; patch = true; }
        else { filtered = cands; patch = true; }
      }
    }
    return { list: rank(filtered, step), patch: patch, i: 0 };
  }

  function buildRoutine() {
    state.steps = {};
    ROUTINE.forEach(function (s) { state.steps[s] = pickForStep(s); });
    // boosters by concern
    state.boosters = [];
    var map = { 'anti-aging': 'eye-care', 'dark-spots': 'eye-care', 'hydration': 'mask', 'soothing': 'mask', 'acne': 'mask', 'pores': 'mask' };
    var bstep = map[state.concern];
    if (bstep) {
      var b = pickForStep(bstep);
      if (b.list.length) state.boosters.push({ step: bstep, data: b });
    }
  }

  /* ---------- why-this copy ---------- */
  function whyLine(step, p) {
    var T = state.type, c = state.concern, sens = state.sensitive, spf = state.spf;
    var tw = { dry: 'dry', oily: 'oily', combination: 'combination', normal: 'balanced' }[T];
    var cp = { acne: 'calm breakouts', 'dark-spots': 'fade dark spots', hydration: 'lock in hydration', soothing: 'soothe redness', 'anti-aging': 'smooth fine lines', pores: 'keep pores clear' }[c];
    var hasC = c && c !== 'none' && p.tags.indexOf('concern:' + c) > -1;
    if (step === 'cleanser') return sens ? 'Fragrance-free first step — lifts the day off ' + tw + ' skin without setting off redness.' : 'A gentle first step for ' + tw + ' skin — cleans without that tight, stripped feeling.';
    if (step === 'toner') return hasC ? 'Hydrates while it helps ' + cp + '.' : 'Preps and hydrates ' + tw + ' skin so everything after absorbs better.';
    if (step === 'serum') {
      if (sens && c === 'acne') return 'You flagged breakouts and sensitivity, so we kept this one calming — no harsh acids.';
      if (hasC) return 'Your treat step — targeted to ' + cp + ' on ' + tw + ' skin.';
      return 'A do-everything serum to keep ' + tw + ' skin healthy and even.';
    }
    if (step === 'moisturizer') {
      var base = { dry: 'Dry skin + drier air → a richer cream to lock moisture in.', oily: "Lightweight hydration that won't clog — moisture without the grease.", combination: 'Balances both zones — enough for dry cheeks, light for the T-zone.', normal: 'Daily moisture to keep your barrier happy and protected.' }[T];
      return sens ? base + ' Fragrance-free, so it won\'t trigger reactivity.' : base;
    }
    if (step === 'sunscreen') {
      if (spf) return "You're outdoors often and skip SPF — this is the one to actually wear daily.";
      if (sens) return "A gentle finish that protects without stinging reactive skin.";
      return 'The step that prevents most visible aging — wear it every morning.';
    }
    // boosters
    if (step === 'eye-care') return 'A targeted extra for the delicate eye area.';
    if (step === 'mask') return 'A weekly boost for your ' + (cp || 'skin') + '.';
    return '';
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  /* ---------- render ---------- */
  var screens = {
    intro: root.querySelector('[data-sq-screen="intro"]'),
    quiz: root.querySelector('[data-sq-screen="quiz"]'),
    result: root.querySelector('[data-sq-screen="result"]')
  };
  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== name); });
    var bar = root.querySelector('[data-sq-bar]');
    if (name === 'intro') bar.style.width = '0%';
    if (name === 'result') bar.style.width = '100%';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function renderQuestion() {
    var q = Q[state.idx];
    var total = Q.length;
    root.querySelector('[data-sq-count]').textContent = 'Question ' + (state.idx + 1) + ' of ' + total;
    var eb = root.querySelector('[data-sq-q-eyebrow]'); if (eb) eb.textContent = q.eyebrow || '';
    root.querySelector('[data-sq-q-title]').textContent = q.title;
    var bar = root.querySelector('[data-sq-bar]');
    bar.style.width = Math.round(((state.idx) / total) * 100) + '%';
    var wrap = root.querySelector('[data-sq-options]');
    wrap.innerHTML = '';
    q.options.forEach(function (o, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sq-opt'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', state.answers[q.id] === i ? 'true' : 'false');
      b.innerHTML = '<span class="sq-opt__dot" aria-hidden="true"></span><span>' + o.l + '</span>';
      b.addEventListener('click', function () { choose(i); });
      wrap.appendChild(b);
    });
    root.querySelector('[data-sq-back]').hidden = state.idx === 0;
    root.querySelector('[data-sq-skip]').hidden = !q.optional;
    root.querySelector('[data-sq-micro]').textContent = MICRO[state.idx] || '';
  }

  function choose(i) {
    var q = Q[state.idx];
    state.answers[q.id] = i;
    recompute();
    setTimeout(next, 180);
  }
  function next() {
    if (state.idx < Q.length - 1) { state.idx++; renderQuestion(); }
    else finish();
  }
  function back() { if (state.idx > 0) { state.idx--; renderQuestion(); } }
  function skip() { var q = Q[state.idx]; delete state.answers[q.id]; recompute(); next(); }

  function finish() { recompute(); buildRoutine(); renderResult(); show('result'); }

  function renderResult() {
    var head = TYPE_NAME[state.type] || 'Normal';
    root.querySelector('[data-sq-type-head]').textContent = 'Your skin leans ' + head + (state.sensitive ? ' — and reactive' : '');
    var edu = TYPE_COPY[state.type] || TYPE_COPY.normal;
    if (state.sensitive) edu += " Your skin also flags as reactive, so we've kept every pick fragrance- and irritant-free.";
    root.querySelector('[data-sq-edu]').textContent = edu;
    var band = root.querySelector('[data-sq-band]');
    var bandImg = root.getAttribute('data-band-image');
    if (bandImg) band.style.backgroundImage = "url('" + bandImg + "')";

    var shop = root.querySelector('[data-sq-shop-all]');
    shop.href = '/collections/' + state.type; // dry / oily / combination / normal collections
    shop.textContent = 'Shop all for ' + (TYPE_NAME[state.type] || '') + ' skin →';

    var stepsWrap = root.querySelector('[data-sq-steps]');
    stepsWrap.innerHTML = '';
    ROUTINE.forEach(function (s, i) { stepsWrap.appendChild(cardEl(s, i + 1)); });

    // boosters
    var bWrap = root.querySelector('[data-sq-boosters]');
    var bList = root.querySelector('[data-sq-booster-list]');
    bList.innerHTML = '';
    if (state.boosters.length) {
      bWrap.hidden = false;
      state.boosters.forEach(function (b) { bList.appendChild(cardEl(b.step, null, true)); });
    } else { bWrap.hidden = true; }

    updateTotal();
  }

  function currentProduct(step, booster) {
    var src = booster ? findBooster(step) : state.steps[step];
    if (!src || !src.list.length) return null;
    return { p: src.list[src.i % src.list.length], src: src };
  }
  function findBooster(step) { for (var i = 0; i < state.boosters.length; i++) if (state.boosters[i].step === step) return state.boosters[i].data; return null; }

  function cardEl(step, num, booster) {
    var cur = currentProduct(step, booster);
    var card = document.createElement('div');
    card.className = 'sq-card'; card.setAttribute('data-sq-card', step); if (booster) card.setAttribute('data-booster', '1');
    if (!cur) { card.innerHTML = '<div class="sq-card__body"><p class="sq-card__why">No match — browse the collection.</p></div>'; return card; }
    card.appendChild(cardInner(step, num, booster));
    return card;
  }

  function cardInner(step, num, booster) {
    var cur = currentProduct(step, booster);
    var p = cur.p, src = cur.src;
    var frag = document.createElement('div'); frag.style.display = 'contents';
    var multi = src.list.length > 1;
    var spf = (step === 'sunscreen' && state.spf);
    var img = p.image ? '<img src="' + p.image + '" alt="' + escapeAttr(p.title) + '" loading="lazy">' : '';
    var swap = multi ? '<div class="sq-card__swap"><button type="button" data-sq-prev aria-label="Previous option">‹</button><button type="button" data-sq-next aria-label="Next option">›</button></div>' : '';
    var note = (src.patch ? '<p class="sq-card__why sq-card__why--note">Patch-test first — it\'s a touch stronger for reactive skin.</p>' : '');
    frag.innerHTML =
      '<div class="sq-card__step">' + (num ? '<span class="sq-card__num">' + num + '</span>' : '') + (STEP_LABEL[step] || step) + '</div>' +
      '<div class="sq-card__media">' + img + swap + '</div>' +
      '<div class="sq-card__body">' +
        '<a class="sq-card__title" href="' + p.url + '">' + p.title + '</a>' +
        '<p class="sq-card__price">' + money(p.price) + '</p>' +
        (spf ? '<p class="sq-card__spf">Don\'t skip this one</p>' : '') +
        '<p class="sq-card__why">' + whyLine(step, p) + '</p>' + note +
        '<div class="sq-card__add"><button type="button" data-sq-add>Add to bag</button></div>' +
      '</div>';
    // wire swap + add
    var prev = frag.querySelector('[data-sq-prev]'), nxt = frag.querySelector('[data-sq-next]');
    if (prev) prev.addEventListener('click', function () { src.i = (src.i - 1 + src.list.length) % src.list.length; replaceCard(step, num, booster); });
    if (nxt) nxt.addEventListener('click', function () { src.i = (src.i + 1) % src.list.length; replaceCard(step, num, booster); });
    var add = frag.querySelector('[data-sq-add]');
    add.addEventListener('click', function () { addToCart([p.variantId], add); });
    return frag;
  }

  function replaceCard(step, num, booster) {
    var card = root.querySelector('[data-sq-card="' + step + '"]' + (booster ? '[data-booster]' : ':not([data-booster])'));
    if (!card) return;
    card.innerHTML = '';
    card.appendChild(cardInner(step, num, booster));
    updateTotal();
  }

  function updateTotal() {
    var sum = 0;
    ROUTINE.forEach(function (s) { var c = currentProduct(s); if (c) sum += c.p.price; });
    root.querySelector('[data-sq-total]').textContent = money(sum);
  }

  /* ---------- cart ---------- */
  function addToCart(ids, btn) {
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    // fetch() does not reject on 422 (sold out) — check r.ok so we never flash a false "Added ✓".
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) { var e = new Error((data && (data.description || data.message)) || 'Could not add'); e.soldOut = (r.status === 422); throw e; } return data; }); })
      .then(function () {
        if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); btn.disabled = false; }
        refreshCart();
      })
      .catch(function (err) {
        if (btn) { btn.textContent = (err && err.soldOut) ? 'Sold out' : 'Try again'; btn.disabled = false; }
      });
  }
  function addAll(btn) {
    var ids = [];
    ROUTINE.forEach(function (s) { var c = currentProduct(s); if (c) ids.push(c.p.variantId); });
    if (!ids.length) return;
    btn.disabled = true; btn.textContent = 'Adding routine…';
    // Shopify's batch /cart/add.js is atomic — one sold-out item fails the whole routine.
    // Add each item on its own so a partial routine still succeeds, and report honestly.
    var added = 0, total = ids.length;
    var jobs = ids.map(function (id) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { if (r.ok) added++; })
        .catch(function () {});
    });
    Promise.all(jobs).then(function () {
      btn.disabled = false;
      if (added > 0) {
        btn.textContent = (added < total) ? ('Added ' + added + ' of ' + total + ' — some sold out') : 'Routine added ✓';
        refreshCart();
        openCart();
      } else {
        btn.textContent = 'Sold out — try again';
      }
    });
  }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-lv-cart-count], .lv-cart-count, .cart-count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function () {});
  }
  function openCart() {
    // best-effort: trigger the theme's side cart; fall back to /cart link shown in UI
    var trig = document.querySelector('.js-show-cart, [data-action="open-cart"], a[href="/cart"], .header-cart, .site-header__cart');
    if (trig && trig.tagName !== 'A') { trig.click(); return; }
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  /* ---------- Klaviyo ---------- */
  var klaviyoSent = false;
  function submitEmail(email) {
    if (klaviyoSent) return Promise.resolve();
    klaviyoSent = true;
    var company = root.getAttribute('data-klaviyo-company') || 'WHPLHq';
    var list = (root.getAttribute('data-klaviyo-list') || '').trim();
    if (list === 'StVWVi') list = ''; // safety: never add quiz-takers to the Welcome Series list
    var props = { skin_type: state.type, concern: state.concern, sensitive: state.sensitive, spf_flag: state.spf };
    var rev = '2024-10-15';
    // onsite identify (if loaded)
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(Object.assign({ $email: email }, props)); } catch (e) {}
    // subscription to the dedicated list (skipped if no list configured). The single-opt-in
    // list sets email-marketing consent automatically — do NOT send a `subscriptions` block here
    // (the /client/subscriptions endpoint rejects it with HTTP 400).
    var subP = list ? fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: rev },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Skin Quiz', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
    }).then(function (r) { if (!r.ok) console.warn('[skin-quiz] Klaviyo subscription failed: HTTP ' + r.status); return r; })
      .catch(function (e) { console.warn('[skin-quiz] Klaviyo subscription error:', e); }) : Promise.resolve();
    // event
    var evP = fetch('https://a.klaviyo.com/client/events/?company_id=' + company, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: rev },
      body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: 'Completed Skin Quiz' } } }, properties: props, profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } } } })
    }).then(function (r) { if (!r.ok) console.warn('[skin-quiz] Klaviyo event failed: HTTP ' + r.status); return r; })
      .catch(function (e) { console.warn('[skin-quiz] Klaviyo event error:', e); });
    return Promise.all([subP, evP]);
  }

  /* ---------- events ---------- */
  root.querySelector('[data-sq-start]').addEventListener('click', function () { state.idx = 0; renderQuestion(); show('quiz'); });
  root.querySelector('[data-sq-back]').addEventListener('click', back);
  root.querySelector('[data-sq-skip]').addEventListener('click', skip);
  root.querySelector('[data-sq-add-all]').addEventListener('click', function () { addAll(this); });
  root.querySelector('[data-sq-restart]').addEventListener('click', function () { state.answers = {}; state.idx = 0; recompute(); show('intro'); });

  var form = root.querySelector('[data-sq-email-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = root.querySelector('[data-sq-email-input]');
    var msg = root.querySelector('[data-sq-email-msg]');
    var email = (input.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.hidden = false; msg.textContent = 'Please enter a valid email.'; return; }
    msg.hidden = true;
    submitEmail(email).then(function () {
      form.hidden = true;
      root.querySelector('[data-sq-email-success]').hidden = false;
    });
  });
  root.querySelector('[data-sq-copy]').addEventListener('click', function () {
    var code = root.querySelector('[data-sq-code]').textContent;
    if (navigator.clipboard) navigator.clipboard.writeText(code);
    this.textContent = 'Copied';
    var self = this; setTimeout(function () { self.textContent = 'Copy'; }, 1500);
  });

  // intro image
  var introImg = root.querySelector('[data-sq-intro-img]');
  if (introImg) introImg.src = root.getAttribute('data-intro-image');

  function escapeAttr(s) { return String(s).replace(/"/g, '&quot;'); }

  // keyboard: number keys select option
  document.addEventListener('keydown', function (e) {
    if (screens.quiz.hidden) return;
    var n = parseInt(e.key, 10);
    if (n >= 1 && n <= 9) { var opts = root.querySelectorAll('[data-sq-options] .sq-opt'); if (opts[n - 1]) opts[n - 1].click(); }
  });
})();
